var _path, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon23(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 46,
    viewBox: "0 0 49 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -3.7643,
    y: -3.76784,
    width: 50.5384,
    height: 50.5379
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.86px)",
      clipPath: "url(#bgblur_0_4293_2310_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 5.72811,
    d: "M24.8899 2.41964L9.04539 6.66516C3.27142 8.21229 0.876491 12.36 2.42348 18.1334L6.66457 33.9614C8.21155 39.7348 12.3595 42.1293 18.1334 40.5822L33.978 36.3367C39.7519 34.7895 42.1318 30.6459 40.5848 24.8725L36.3437 9.04451C34.7967 3.27108 30.6639 0.872503 24.8899 2.41964Z",
    fill: "url(#paint0_linear_4293_2310)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_4293_2310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6971 23.1624L29.8198 12.2632C28.7762 8.30982 26.1641 6.53715 22.7295 7.44385L11.097 10.5147C7.60612 11.4363 6.25439 14.2554 7.29806 18.2088L10.1754 29.108C11.2359 33.1251 13.7857 34.8447 17.2766 33.9231L28.9091 30.8522C32.3437 29.9455 33.7576 27.1796 32.6971 23.1624Z",
    fill: "#C9E6FF"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 5.84902,
    y: 2.83651,
    width: 49.2135,
    height: 49.2134
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3.3px)",
      clipPath: "url(#bgblur_1_4293_2310_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 6.60935
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_4293_2310",
    maskUnits: "userSpaceOnUse",
    x: 11.899,
    y: 8.88647,
    width: 37,
    height: 37,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 11.899,
    y: 8.88647,
    width: 37,
    height: 37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6645 9.88647H22.2626C16.2855 9.88647 12.899 13.273 12.899 19.2501V35.6364C12.899 41.6135 16.2855 45 22.2626 45H38.6645C44.6416 45 48.0125 41.6135 48.0125 35.6364V19.2501C48.0125 13.273 44.6416 9.88647 38.6645 9.88647Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.6645 9.88647H22.2626C16.2855 9.88647 12.899 13.273 12.899 19.2501V35.6364C12.899 41.6135 16.2855 45 22.2626 45H38.6645C44.6416 45 48.0125 41.6135 48.0125 35.6364V19.2501C48.0125 13.273 44.6416 9.88647 38.6645 9.88647Z",
    fill: "#94D4FF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6645 10.3271C38.9078 10.3271 39.1051 10.1298 39.1051 9.88647C39.1051 9.64312 38.9078 9.44585 38.6645 9.44585V9.88647V10.3271ZM38.6645 9.44585C38.4211 9.44585 38.2239 9.64312 38.2239 9.88647C38.2239 10.1298 38.4211 10.3271 38.6645 10.3271V9.88647V9.44585ZM38.6645 9.88647V9.44585H22.2626V9.88647V10.3271H38.6645V9.88647ZM22.2626 9.88647V9.44585C19.1921 9.44585 16.726 10.3171 15.0278 12.0153C13.3296 13.7135 12.4584 16.1796 12.4584 19.2501H12.899H13.3396C13.3396 16.3434 14.1616 14.1278 15.6509 12.6384C17.1403 11.1491 19.356 10.3271 22.2626 10.3271V9.88647ZM12.899 19.2501H12.4584V35.6364H12.899H13.3396V19.2501H12.899ZM12.899 35.6364H12.4584C12.4584 38.7068 13.3296 41.173 15.0278 42.8712C16.726 44.5694 19.1921 45.4406 22.2626 45.4406V45V44.5594C19.356 44.5594 17.1403 43.7374 15.6509 42.248C14.1616 40.7587 13.3396 38.543 13.3396 35.6364H12.899ZM22.2626 45V45.4406H38.6645V45V44.5594H22.2626V45ZM38.6645 45V45.4406C41.735 45.4406 44.1975 44.5693 45.8919 42.8708C47.5861 41.1724 48.4531 38.7063 48.4531 35.6364H48.0125H47.5719C47.5719 38.5436 46.7535 40.7593 45.268 42.2484C43.7826 43.7374 41.5711 44.5594 38.6645 44.5594V45ZM48.0125 35.6364H48.4531V19.2501H48.0125H47.5719V35.6364H48.0125ZM48.0125 19.2501H48.4531C48.4531 16.1802 47.5861 13.7141 45.8919 12.0157C44.1975 10.3171 41.735 9.44585 38.6645 9.44585V9.88647V10.3271C41.5711 10.3271 43.7826 11.1491 45.268 12.638C46.7535 14.1272 47.5719 16.3429 47.5719 19.2501H48.0125Z",
    fill: "url(#paint1_linear_4293_2310)",
    mask: "url(#path-3-outside-1_4293_2310)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 14.2639,
    y: 10.4561,
    width: 32.3987,
    height: 33.9596
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3.3px)",
      clipPath: "url(#bgblur_2_4293_2310_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4293_2310)",
    "data-figma-bg-blur-radius": 6.60935
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_4293_2310",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5178 17.0654C29.7219 17.0654 29.0665 17.7209 29.0665 18.5324V36.3544C29.0665 37.1504 29.7219 37.8058 30.5178 37.8058C31.3294 37.8058 31.9848 37.1504 31.9848 36.3544V18.5324C31.9848 17.7209 31.3294 17.0654 30.5178 17.0654ZM22.3246 22.8246C21.5287 22.8246 20.8733 23.48 20.8733 24.2915V36.355C20.8733 37.1509 21.5287 37.8063 22.3246 37.8063C23.1362 37.8063 23.7916 37.1509 23.7916 36.355V24.2915C23.7916 23.48 23.1362 22.8246 22.3246 22.8246ZM37.135 30.6586C37.135 29.8471 37.7904 29.1917 38.6019 29.1917C39.3979 29.1917 40.0533 29.8471 40.0533 30.6586V36.3548C40.0533 37.1507 39.3979 37.8062 38.5863 37.8062C37.7904 37.8062 37.135 37.1507 37.135 36.3548V30.6586Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5178 17.0654C29.7219 17.0654 29.0665 17.7209 29.0665 18.5324V36.3544C29.0665 37.1504 29.7219 37.8058 30.5178 37.8058C31.3294 37.8058 31.9848 37.1504 31.9848 36.3544V18.5324C31.9848 17.7209 31.3294 17.0654 30.5178 17.0654ZM22.3246 22.8246C21.5287 22.8246 20.8733 23.48 20.8733 24.2915V36.355C20.8733 37.1509 21.5287 37.8063 22.3246 37.8063C23.1362 37.8063 23.7916 37.1509 23.7916 36.355V24.2915C23.7916 23.48 23.1362 22.8246 22.3246 22.8246ZM37.135 30.6586C37.135 29.8471 37.7904 29.1917 38.6019 29.1917C39.3979 29.1917 40.0533 29.8471 40.0533 30.6586V36.3548C40.0533 37.1507 39.3979 37.8062 38.5863 37.8062C37.7904 37.8062 37.135 37.1507 37.135 36.3548V30.6586Z",
    fill: "url(#paint2_linear_4293_2310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0665 18.5324H29.2427C29.2427 17.817 29.8205 17.2417 30.5178 17.2417V17.0654V16.8892C29.6234 16.8892 28.8902 17.6248 28.8902 18.5324H29.0665ZM29.0665 36.3544H29.2427V18.5324H29.0665H28.8902V36.3544H29.0665ZM30.5178 37.8058V37.6296C29.8193 37.6296 29.2427 37.053 29.2427 36.3544H29.0665H28.8902C28.8902 37.2477 29.6246 37.9821 30.5178 37.9821V37.8058ZM31.9848 36.3544H31.8086C31.8086 37.0518 31.2332 37.6296 30.5178 37.6296V37.8058V37.9821C31.4255 37.9821 32.1611 37.2489 32.1611 36.3544H31.9848ZM31.9848 18.5324H31.8086V36.3544H31.9848H32.1611V18.5324H31.9848ZM30.5178 17.0654V17.2417C31.232 17.2417 31.8086 17.8182 31.8086 18.5324H31.9848H32.1611C32.1611 17.6235 31.4267 16.8892 30.5178 16.8892V17.0654ZM20.8733 24.2915H21.0495C21.0495 23.5761 21.6273 23.0008 22.3246 23.0008V22.8246V22.6483C21.4302 22.6483 20.697 23.3839 20.697 24.2915H20.8733ZM20.8733 36.355H21.0495V24.2915H20.8733H20.697V36.355H20.8733ZM22.3246 37.8063V37.6301C21.6261 37.6301 21.0495 37.0535 21.0495 36.355H20.8733H20.697C20.697 37.2482 21.4314 37.9826 22.3246 37.9826V37.8063ZM23.7916 36.355H23.6154C23.6154 37.0523 23.0401 37.6301 22.3246 37.6301V37.8063V37.9826C23.2323 37.9826 23.9679 37.2494 23.9679 36.355H23.7916ZM23.7916 24.2915H23.6154V36.355H23.7916H23.9679V24.2915H23.7916ZM22.3246 22.8246V23.0008C23.0388 23.0008 23.6154 23.5774 23.6154 24.2915H23.7916H23.9679C23.9679 23.3827 23.2335 22.6483 22.3246 22.6483V22.8246ZM38.6019 29.1917V29.0154C37.6931 29.0154 36.9587 29.7498 36.9587 30.6586H37.135H37.3112C37.3112 29.9445 37.8878 29.3679 38.6019 29.3679V29.1917ZM40.0533 30.6586H40.2296C40.2296 29.751 39.4964 29.0154 38.6019 29.0154V29.1917V29.3679C39.2993 29.3679 39.8771 29.9432 39.8771 30.6586H40.0533ZM40.0533 36.3548H40.2296V30.6586H40.0533H39.8771V36.3548H40.0533ZM38.5863 37.8062V37.9824C39.494 37.9824 40.2296 37.2493 40.2296 36.3548H40.0533H39.8771C39.8771 37.0522 39.3017 37.6299 38.5863 37.6299V37.8062ZM37.135 36.3548H36.9587C36.9587 37.2481 37.6931 37.9824 38.5863 37.9824V37.8062V37.6299C37.8878 37.6299 37.3112 37.0534 37.3112 36.3548H37.135ZM37.135 30.6586H36.9587V36.3548H37.135H37.3112V30.6586H37.135Z",
    fill: "url(#paint3_linear_4293_2310)",
    mask: "url(#path-5-inside-2_4293_2310)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_4293_2310_clip_path",
    transform: "translate(3.7643 3.76784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8899 2.41964L9.04539 6.66516C3.27142 8.21229 0.876491 12.36 2.42348 18.1334L6.66457 33.9614C8.21155 39.7348 12.3595 42.1293 18.1334 40.5822L33.978 36.3367C39.7519 34.7895 42.1318 30.6459 40.5848 24.8725L36.3437 9.04451C34.7967 3.27108 30.6639 0.872503 24.8899 2.41964Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4293_2310",
    x: 1.22621,
    y: 1.48314,
    width: 37.5445,
    height: 38.4111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.86405,
    result: "effect1_foregroundBlur_4293_2310"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_4293_2310_clip_path",
    transform: "translate(-5.84902 -2.83651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6645 9.88647H22.2626C16.2855 9.88647 12.899 13.273 12.899 19.2501V35.6364C12.899 41.6135 16.2855 45 22.2626 45H38.6645C44.6416 45 48.0125 41.6135 48.0125 35.6364V19.2501C48.0125 13.273 44.6416 9.88647 38.6645 9.88647Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4293_2310",
    x: 14.2639,
    y: 10.4561,
    width: 32.3987,
    height: 33.9596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.20312,
    dy: 2.20312
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.20312
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.580392 0 0 0 0 0.831373 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4293_2310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4293_2310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_4293_2310_clip_path",
    transform: "translate(-14.2639 -10.4561)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5178 17.0654C29.7219 17.0654 29.0665 17.7209 29.0665 18.5324V36.3544C29.0665 37.1504 29.7219 37.8058 30.5178 37.8058C31.3294 37.8058 31.9848 37.1504 31.9848 36.3544V18.5324C31.9848 17.7209 31.3294 17.0654 30.5178 17.0654ZM22.3246 22.8246C21.5287 22.8246 20.8733 23.48 20.8733 24.2915V36.355C20.8733 37.1509 21.5287 37.8063 22.3246 37.8063C23.1362 37.8063 23.7916 37.1509 23.7916 36.355V24.2915C23.7916 23.48 23.1362 22.8246 22.3246 22.8246ZM37.135 30.6586C37.135 29.8471 37.7904 29.1917 38.6019 29.1917C39.3979 29.1917 40.0533 29.8471 40.0533 30.6586V36.3548C40.0533 37.1507 39.3979 37.8062 38.5863 37.8062C37.7904 37.8062 37.135 37.1507 37.135 36.3548V30.6586Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4293_2310",
    x1: 24.6099,
    y1: 23.105,
    x2: -1.31103,
    y2: 45.5839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4293_2310",
    x1: 18.4885,
    y1: 13.9772,
    x2: 40.8872,
    y2: 41.7186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4293_2310",
    x1: 15.9086,
    y1: 32.4597,
    x2: 24.8933,
    y2: 50.9176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4293_2310",
    x1: 23.9264,
    y1: 19.4818,
    x2: 37.3372,
    y2: 34.8413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon23);
export default __webpack_public_path__ + "static/media/icon23.02931329701aa9afc86dcc9639b6cb72.svg";
export { ForwardRef as ReactComponent };